<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Definición de indicadores área {{this.area}}</h4>
            </v-flex>
          </v-layout>

               <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label for="usr">Debilidades</label>
              <select class="form-control" id="5" v-model="debilidad" @change="debilidadF()" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(debilidad,index) in debilidades"
                  :key="index"
                  :value="debilidad"
                >{{debilidad.descripcion}}</option>
              </select>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label for="usr">Objetivos</label>
              <select class="form-control" id="5" v-model="objetivo"  @change="objetivoF()" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(objetivo,index) in objetivos"
                  :key="index"
                  :value="objetivo"
                >{{objetivo.descripcion}}</option>
              </select>
            </v-flex>
          </v-layout>
          <br />

          <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
            <v-layout>
              <v-flex md12 lg12 xs12 sm12 xl12>
                <table class="table table-striped header-fixed">
                  <thead>
                    <tr>
                      <th
                        style="text-align: center"
                        :class="header.border"
                        v-for="(header,index) in headers"
                        :key="index"
                      >{{header.text}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in indicadores" :key="index">
                      <td style="text-align:left " :class="headers[0].size">{{item.descripcion}}</td>
                      <td style="text-align:left " :class="headers[1].size">{{item.meta}}</td>
                     
                      <td :class="headers[2].size">
                        <v-icon
                          :disabled="($session.getAll().puedeEditar == false) "
                          small
                          class="mr-2"
                          @click="openeditHito(item,index)"
                        >edit</v-icon>
                      </td>
                      <td :class="headers[3].size">
                        <v-icon small class="mr-2" @click="viewDocument(item)">add</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-flex>
      </v-flex>


    </v-layout>
    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="confirm" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-auto">
            <v-card-title>
              <span class="headline">¿Desea aprobar el indicador?</span>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="confirm = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" @click="checkPlan()">aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

   <!--  <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="comentario" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-auto">
            <v-card-title>
              <span class="headline">Comentario de Acción</span>
            </v-card-title>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="comment">Comentario</label>
                <textarea
                  v-model="actividad.estadoAprobacion"
                  rows="9"
                  class="form-control"
                  id="comment"
                />
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#ec6a12" flat="flat" @click="comentario = false">Cerrar</v-btn>
              <v-btn color="#394049" flat="flat" @click="updateComentario()">Enviar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout> -->

    <v-layout>
      <v-dialog v-model="edit" width="600px" persistent>
        <v-card class="v-card-dialog">
          <v-card-title>
            <span class="headline" >Editar indicador</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre del indicador</label>
                <textarea
                  v-model="indicador.descripcion"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Meta</label>
                <textarea
                  v-model="indicador.meta"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>         
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="editHito()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>


  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_7.png";
import img3 from "../../../assets/nuevaasistenciadca.png";

export default {
  data() {
    return {
      area: "",
      eliminar: false,
      comentario: false,
      descripcion: "",
      tipodimension: " ",
      indicador: "",
      img3: img3,
      asistencia: false,
      debilidades: [],
      debilidad: "",
      objetivos: [],
      objetivo: "",
      indicadores: [],
      nEtapa: 4,
      etapa: "",
     
      edit: false,
      index: "",
      dialog: false,
      hito: {},
      headers: [
        {
          text: "Indicador",
          value: "name",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5",
          border: "col-md-5 col-lg-5 col-sm-5 col-xs-5 th-border"
        },
        {
          text: "Meta",
          value: "muy desacuerdo",
          size: "col-md-5 col-lg-5 col-sm-5 col-xs-5",
          border: "col-md-5 col-lg-5 col-sm-5 col-xs-5 th-border"
        },
        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        },
        {
          text: "Docs",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],
      headers2: [
        {
          text: "",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "",
          value: "muy desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text: "Últimos años de cumplimiento",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      confirm: false,
      right: null
    };
  },


  watch: { // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }},

  created() {
    //console.log(this.$session.getAll().puedeEditar);
    // Con esto, me traera las debilidades
     this.initComponent()
  },

 

  methods: {
  initComponent(){
      if (this.$route.params.id == "1" ) this.area = "Gestión";
      if (this.$route.params.id =="2") this.area = "Pregrado";
      if (this.$route.params.id =="3") this.area = "Postgrado";
      if (this.$route.params.id =="4") this.area = "Investigación";
      if (this.$route.params.id =="5") this.area = "Vinculación con el medio";

       axios
      .get(process.env.ROOT_API + "/debilidad/getAllByArea?area=" + this.$route.params.id, {
        headers: { Authorization: "" + this.$session.get("jwt") }
      })
      .then(response => {
        //console.log("debilidades");
        console.log(response.data);
        this.debilidades = response.data;
        this.debilidad = this.debilidades[0];
        // Con esto me traerá los objetivos
        axios
          .get(
            process.env.ROOT_API +
              "/objetivo/getAllByDebilidad?idDebilidad=" +
              this.debilidad.id,
            {
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            console.log("Objetivos");
            console.log(response.data);
            this.objetivos = response.data;
            this.objetivo = this.objetivos[0];
            // Con esto me traerá las estrategias

            axios
              .get(
                process.env.ROOT_API +
                  "/indicador/getAllByObjetivo?idObjetivo=" +
                  this.objetivo.id,
                {
                  headers: { Authorization: "" + this.$session.get("jwt") }
                }
              )
              .then(response => {
                console.log("Indicadores");
                console.log(response.data);
                this.indicadores = response.data;
                // Con esto me traerá las estrategias
              })
              .catch(error => {
                console.error(error);
              });
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        console.error(error);
      });
    },

    redirect(index) {
      this.typeEstrategico = index;
    },
   
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

  


    viewDocument(item) {
      this.$router.push({ name: "indicadoresDoc", params: { id: item.id } });
    },

   

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          "http://localhost:8089/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    openeditHito(hito, index) {
      this.edit = true;
      this.index = index;
      this.indicador = hito;
    },



  /*   updateComentario() {
      const comentario = {
        comentario: this.actividad.estadoAprobacion
      };
      axios
        .patch(
          process.env.ROOT_API +
            "/actividad/updateComentarioAccion?idActividad=" +
            this.actividad.id,
          comentario,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          this.comentario = false;
          alert("Acción editada");
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    }, */

    editHito() {
      this.edit = false;
      axios
        .patch(
          process.env.ROOT_API + "/hito/updateHito?etapa=1",
          this.hito,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Indicador Actualizado");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },



    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },
 
    debilidadF() {
      //console.log("whatcher a detectado un cambio en user");
      axios
        .get(
          process.env.ROOT_API +
            "/objetivo/getAllByDebilidad?idDebilidad=" +
            this.debilidad.id,
          {
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          console.log("Objetivos");
          console.log(response.data);
          this.objetivos = response.data;
          this.objetivo = this.objetivos[0];
          // Con esto me traerá las estrategias

          axios
            .get(
              process.env.ROOT_API +
                "/indicador/getAllByObjetivo?idObjetivo=" +
                this.objetivo.id,
              {
                headers: { Authorization: "" + this.$session.get("jwt") }
              }
            )
            .then(response => {
              console.log("Indicadores");
              console.log(response.data);
              this.indicadores = response.data;
              // Con esto me traerá las estrategias
            })
            .catch(error => {
              console.error(error);
            });
        })
        .catch(error => {
          console.error(error);
        });
    },

    objetivoF() {
      //console.log("whatcher a detectado un cambio en user");
      axios
        .get(
          process.env.ROOT_API +
            "/indicador/getAllByObjetivo?idObjetivo=" +
            this.objetivo.id,
          {
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          console.log("Indicadores");
          console.log(response.data);
          this.indicadores = response.data;
          // Con esto me traerá las estrategias
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

.v-card-dialog {
  height: auto !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/mejoramiento/DefinicionIndicadores.vue